/********************  START WEB API SLUG ************* */

// Prefixed WEB URL

//Athencation
const ADMIN = "/api/admin/";
const API = "/api/";
export const LOGIN = "login";

// dashboard Data
export const GET_DASHBOARD_DATA = API + "dashboard-data";

export const CONTACT_US = API + "conatct-us";

// user
export const GET_USER_LIST = API + "users-list";
export const DELETE_USER = API + "users-delete";
export const SAVE_USER_DATA = API + "users-add";
export const UPDATE_USER_DATA = API + "users-update";
export const GET_USER_DETAIL = API + "user-get-by-id";
export const GET_CLIENT_DETAIL_BY_ID = API + "get-client-by-id";

// client
export const GET_CLIENT_LIST = API + "users-list";
export const DELETE_CLIENT = API + "users-delete";
export const SAVE_CLIENT_DATA = API + "users-add";
export const UPDATE_CLIENT_DATA = API + "users-update";
export const GET_CLIENT_DETAIL = API + "client-get-by-id";
export const ADD_CLIENT_CHARGE = API + "update-client-charge-status";

// Employee
export const GET_EMPLOYEE_LIST = API + "users-list";
export const DELETE_EMPLOYEE = API + "users-delete";
export const SAVE_EMPLOYEE_DATA = API + "users-add";
export const UPDATE_EMPLOYEE_DATA = API + "users-update";
export const SAVE_WORKING_HOURS_V1 = API + "add-paystub-data";
export const SAVE_WORKING_HOURS_V2 = API + "add-paystub-data-v2";

// holidays
export const GET_HOLIDAY_LIST = API + "list-holiday";
export const ADD_HOLIDAY = API + "add-holiday";
export const UPDATE_HOLIDAY = API + "update-holiday";
export const DELETE_HOLIDAY = API + "delete-holiday";

// list-employee
export const GET_LIST_EMPLOYEE = API + "list-employee";
export const SAVE_EMPLOYEE_WITH_HOUR = API + "list-employee-working-hour";
export const UPDATE_PAYSTUB_DATA = API + "add-paystub-data";

// PD7A Report
export const GET_PD7A_REPORT = API + "list-pd7a";

export const GET_EMPLOYEE_BY_ID = API + "employee-get-by-id";
// status paid or not
export const PAID_STATUS = API + "change-pd7a-status";

// pay cycle by client id
export const PAY_CYCLE_BY_CLIENT_ID = API + "list-client-pay-cycle";

// t4 report
export const T4_REPORT_LIST = API + "list-t4";

// t4 summary
export const T4_SUMMARY = API + "generate-t4-summary";

// t4 xml
export const T4_XML_LIST = API + "t4-xml-list";

// t4 xml
export const T4_XML = API + "generate-t4-xml";

// pdf print merge
export const INVOICE_PRINT = API + "list-all-pay-stub-url-of-emp";

// generate t4 report
export const T4_GENERATE = API + "generate-t4";

// generete pdf quartely
export const PDF_QUARTELY = API + "generate-quarterly";

// working hour according to paycycle
export const WORKING_HOUR_BY_PAYCYCLE = API + "get-cpp-ei-yeartodt";

// get employee working hour data
export const GET_WORKING_HOUR_DATA = API + "get-preview-paystub-data";

export const GET_SETTING_DATA = ADMIN + "get-global-data";
export const ADD_SETTING_DATA = ADMIN + "global-data-update";

export const GET_NOTIFICATION = ADMIN + "get-notifications";
export const UPDATE_NOTIFICATION = ADMIN + "update-notifications";

// invoice constant start

// invoice id
export const GET_INVOICE_ID = API + "get-invoice-no";

export const SAVE_INVOICE_DATA = API + "add-update-invoice-details";

// get invoice list
export const GET_INVOICE_LIST = API + "invoice-list";

// add sales tax
export const ADD_SALES_TAX_DATA = API + "add-tax-data";

// get service list
export const GET_SERVICE_LIST = API + "services-list";

// add service tax
export const ADD_SERVICE_DATA = API + "add-service";

// get tax list
export const GET_SALES_TAX_LIST = API + "tax-list";

// get invoice payee list
export const GET_INVOICE_PAYEE_LIST = API + "invoice-recipent-list";

// post payee data
export const SAVE_INVOICE_PAYEE_DATA = API + "add-invoice-recipent-data";

// get payee details by dropdown
export const GET_PAYEE_DETAIL_BY_ID = API + "recipent-data-by-id";

// update and send email status
export const SEND_EMAIL_AND_UPDATE_STATUS = API + "update-invoice-status";

// post payment received date
export const PAYMENT_RECEIVED_DATE = API + "update-invoice-payment-status";

// sub contractor api start

// get sub contractor list
export const GET_SUB_CONTRACTOR_LIST = API + "sub-contractor-list";

// post sub contractor detail
export const ADD_SUB_CONTRACTOR_DETAIL = API + "add-sub-contractor-data";
export const BULK_ADD_SUB_CONTRACTOR_PAYMENT = API + "bulk-add-sub-contractor-payment";

// sub contractor get payment list
export const GET_SUB_CONTRACTOR_PAYMENT_LIST = API + "sub-contractor-payment-list";

//   add sub contractor payment detail
export const ADD_SUB_CONTRACTOR_PAYMENT_DETAIL = API + "add-sub-contractor-payment-details";

//   get sub contractor data by id
export const GET_SUB_CONTRACTOR_DATA_BY_ID = API + "sub-contractor-data-by-id";

// update sub contractor payment status
export const UPDATE_SUB_CONTRACTOR_PAYMENT_STATUS = API + "update-sub-contractor-payment-status";

// employee status change active or inactive
export const UPDATE_EMPLOYEE_ACTIVE_STATUS = API + "change-user-status";

// reports route start

// post employee earning summary
export const POST_EMPLOYEE_EARNING_SUMMARY = API + "emp-earning-summary";

// get employee earning summary list
export const GET_REPORT_SUMMARY_LIST = API + "reports";

// post payroll liab balance
export const POST_LIAB_BALANCE = API + "payroll-liab-bal";

// post payroll transaction list
export const POST_PAYROLL_TRANSACTION = API + "payroll-transaction";

// payment method update
export const UPDATE_PAYMENT_METHOD = API + "add-payment-method";

// get profile data by id
export const GET_PROFILE_DATA_BY_ID = API + "get-profile-data-by-id";

// get user invoice list
export const GET_USER_INVOICE_LIST = API + "stripe-invoice-list";

// change default payment card
export const CHANGE_DEFAULT_PAYMENT_CARD = API + "update-cust-default-payment-status";
// view sin number
export const VIEW_SIN_NUMBER = API + "confirm-sin-no";

// get user client payment data from dashboard
export const GET_USER_CLIENT_PAYMENT_DETAILS = API + "users-client-payment-statstic";

// get unverified user list
export const GET_UNVERIFIED_USER_LIST = API + "temp-users-list";

// edit unverified user email
export const EDIT_UNVERIFIED_USER = API + "edit-temp-user";

// send email to unverified user
export const SEND_VERIFY_EMAIL = API + "send-verify-mail";

// get ROE List
export const GET_ROE_LIST = API + "roe-list";

// Re generate Roe
export const RE_GENERATE_ROE = API + "re-generate-roe";

// send payment email in sub Contractor
export const SEND_PAYMENT_EMAIL_SUBCONTRACTOR = API + "send-payment-email";
export const SEND_PAYMENT_EMAIL_BULK_SUBCONTRACTOR = API + "send-payment-email-bulk";

// delete invoice payee
export const DELETE_INVOICE_PAYEE = API + "delete-recipient";

// delete invoice
export const DELETE_INVOICE = API + "delete-invoice";

// delete sub contractor
export const DELETE_SUB_CONTRACTOR = API + "delete-sub-contactor";

// delete sub contractor payment invoice
export const DELETE_SUB_CONTRACTOR_PAYMENT_INVOICE = API + "delete-sub-contactor-payment";

// get sub contractor payment invoice edit
export const GET_SUB_CONTRACTOR_PAYMENT_INVOICE_DETAIL = API + "get-sub-contactor-payment";

// update sub contractor pdf
export const UPDATE_SUB_CONTRACTOR_PDF = API + "update-contactor-payment";

// edit invoice pdf
export const UPDATE_INVOICE_PDF = API + "get-invoice-data";

// delete service
export const DELETE_SERVICE = API + "delete-service";

// generate custom range pd7a
export const GENERATE_CUSTOM_RANGE_PD7A = API + "generate-custom-range-pd7a";
